import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const MuiChip: {
    styleOverrides: ComponentsOverrides<Theme>['MuiChip'];
    defaultProps?: ComponentsProps['MuiChip'];
} = {
    styleOverrides: {
        root: ({ ownerState, theme }) => ({
            ...theme.typography.body1,
            fontWeight: 600,
            height: theme.spacing(5),
            borderRadius: theme.spacing(2.5),
            borderWidth: '1.5px',

            // size "smaller" customization
            ...(ownerState.size === 'smaller' && {
                height: theme.spacing(3.5),
            }),
        }),
    },
};

declare module '@mui/material/Chip' {
    interface ChipPropsSizeOverrides {
        smaller: true;
    }
}
